/* Viretta product.v2 – the product top (sections/v2-product.liquid).
   Variant changes happen here, without a section re-render: the hidden variant id, the URL, price and set line, the
   add-to-cart label, stock, the per-variant blocks ([data-v2-for]), option badges, sold-out marks, the gallery filter
   (same AND/OR alt-tag rule as snippets/product-gallery.liquid) and the set drawer. Add to cart is the theme's own
   product-form, so the cart drawer opens as on every other page. */
(() => {
  if (window.VirettaV2Product) return;
  window.VirettaV2Product = true;

  const lc = (s) => String(s == null ? '' : s).trim().toLowerCase();

  class V2Product {
    constructor(root) {
      this.root = root;
      this.variants = JSON.parse(root.querySelector('[data-v2-variants]').textContent);
      this.config = JSON.parse(root.querySelector('[data-v2-config]').textContent);
      this.form = root.querySelector('form[is="product-form"], .v2-form');
      this.input = root.querySelector('[data-v2-variant-input]');
      this.items = Array.from(root.querySelectorAll('[data-v2-media]'));
      this.track = root.querySelector('[data-v2-track]');
      const id = Number(this.input && this.input.value);
      this.current = this.variants.find((v) => v.id === id) || this.variants[0];
      this.options = this.current.options.slice();

      const title = root.querySelector('.v2-title');
      if (title && title.textContent.trim().length >= 34) title.classList.add('is-long');

      this.bind();
      this.render(false);
      this.fitSticky();
      window.addEventListener('resize', () => this.fitSticky(), { passive: true });
      root.querySelectorAll('details').forEach((d) => d.addEventListener('toggle', () => this.fitSticky()));
    }

    bind() {
      const root = this.root;

      root.querySelectorAll('[data-v2-option]').forEach((box) => {
        const idx = Number(box.dataset.v2Option);
        box.addEventListener('click', (e) => {
          const b = e.target.closest('.v2-seg__b, .v2-sw');
          if (!b || !box.contains(b)) return;
          this.pick(idx, b.dataset.value);
        });
      });

      // owner 9 Oct (round 9): 2 lines → one »Læs mere« shows the rest of the text and the sales points → »Vis mindre«
      const lead3 = root.querySelector('[data-v2-lead3]');
      if (lead3) {
        const m = lead3.querySelector('[data-v2-lead-m]'), pts = lead3.querySelector('[data-v2-pts]');
        const next = lead3.querySelector('[data-v2-lead-next]'), less = lead3.querySelector('[data-v2-lead-less]');
        const set = (step) => {
          lead3.dataset.step = String(step);
          if (m) m.hidden = step < 1;
          if (pts) pts.hidden = step < 2;
          const last = step >= 2 || (step === 1 && !pts) || (step === 0 && !m && !pts);
          next.hidden = last; next.setAttribute('aria-expanded', String(step > 0));
          less.hidden = step === 0;
          this.fitSticky();
        };
        next.addEventListener('click', () => set(2));   // owner 9 Oct: one »Læs mere« – the rest of the text and the sales points together
        less.addEventListener('click', () => set(0));
        set(0);
      }

      // »Læs mere« / »Vis mindre«
      root.querySelectorAll('[data-v2-lead-toggle]').forEach((btn) => btn.addEventListener('click', () => {
        const lead = root.querySelector('[data-v2-lead]');
        const open = lead.querySelector('[data-v2-pts]').hidden;
        lead.querySelector('[data-v2-pts]').hidden = !open;
        lead.querySelector('.v2-lead__less').hidden = !open;
        this.fitSticky();
        const more = lead.querySelector('p [data-v2-lead-toggle]');
        if (more) { more.hidden = open; more.setAttribute('aria-expanded', String(open)); }
      }));

      // Warranty
      const war = root.querySelector('[data-v2-war-toggle]');
      if (war) war.addEventListener('click', () => {
        const body = root.querySelector('.v2-war__body');
        body.hidden = !body.hidden;
        war.setAttribute('aria-expanded', String(!body.hidden));
        war.textContent = body.hidden ? 'Hvad dækker den?' : 'Luk';
      });

      // Set drawer – moved to <body> so it sits above the theme header (the section lives in a stacking context)
      this.drawer = root.querySelector('[data-v2-drawer]');
      if (this.drawer) {
        root.addEventListener('click', (e) => { if (e.target.closest('[data-v2-drawer-open]')) this.openDrawer(); });
        this.drawer.addEventListener('click', (e) => {
          if (e.target.closest('[data-v2-drawer-close]')) { this.closeDrawer(); return; }
          const row = e.target.closest('.v2-jrow');
          if (row) { this.pick(this.config.setIndex, row.dataset.value); this.closeDrawer(); }
        });
        this.portal(this.drawer);
      }

      // »Spar med et sæt« drawer (owner 9 Oct, round 9): every set this variant is part of, one is picked, the theme's own
      // product-form adds it (the cart drawer opens as everywhere else)
      this.updrw = root.querySelector('[data-v2-updrawer]');
      if (this.updrw) {
        root.addEventListener('click', (e) => { if (e.target.closest('[data-v2-updrawer-open]')) this.openUp(); });
        this.updrw.addEventListener('click', (e) => {
          if (e.target.closest('[data-v2-updrawer-close]')) { this.closeUp(); return; }
          const lb = e.target.closest('[data-v2-up-lidbtn]');
          if (lb) { this.upLid(lb.closest('[data-v2-upfor]'), lb.dataset.v2UpLidbtn); return; }
          const row = e.target.closest('[data-v2-up-id]');
          if (row && !row.disabled) this.pickUp(row);
        });
        const upForm = this.updrw.querySelector('form');
        if (upForm) upForm.addEventListener('submit', () => setTimeout(() => this.closeUp(), 60));
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.closeUp(); });
        this.portal(this.updrw);
      }

      // Mobile cart bar
      this.bar = root.querySelector('[data-v2-bar]');
      if (this.bar) {
        this.portal(this.bar);
        this.bar.hidden = false;
        this.bar.querySelector('[data-v2-bar-btn]').addEventListener('click', () => {
          if (this.form.requestSubmit) this.form.requestSubmit(); else this.form.querySelector('[type="submit"]').click();
        });
        const atc = root.querySelector('[data-v2-atc]');
        if (atc && 'IntersectionObserver' in window) {
          new IntersectionObserver(([en]) => {
            const passed = !en.isIntersecting && en.boundingClientRect.top < 0;
            this.bar.classList.toggle('is-on', passed);
          }).observe(atc);
        }
      }

      // Gallery: lightbox + mobile counter
      this.lb = root.querySelector('[data-v2-lightbox]');
      if (this.lb) this.portal(this.lb);
      this.items.forEach((item) => item.addEventListener('click', () => this.openLightbox(item)));
      if (this.lb) {
        this.lb.querySelector('[data-v2-lb-close]').addEventListener('click', () => this.closeLightbox());
        this.lb.querySelector('[data-v2-lb-prev]').addEventListener('click', () => this.stepLightbox(-1));
        this.lb.querySelector('[data-v2-lb-next]').addEventListener('click', () => this.stepLightbox(1));
        this.lb.addEventListener('click', (e) => { if (e.target === this.lb) this.closeLightbox(); });
      }
      if (this.track) {
        let t;
        this.track.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(() => this.updateCount(), 60); }, { passive: true });
      }
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { this.closeLightbox(); this.closeDrawer(); this.closeFilm(); }
        if (this.lb && !this.lb.hidden && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) this.stepLightbox(e.key === 'ArrowLeft' ? -1 : 1);
      });
    }

    /* The buy box sticks by its top when it fits the window, otherwise by its bottom – so everything in it can be reached */
    fitSticky() {
      const el = this.root.querySelector('.v2-buy');
      if (!el) return;
      const head = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height')) || 80;
      const h = el.offsetHeight;
      el.style.top = (h > window.innerHeight - head - 16 ? Math.round(window.innerHeight - h - 24) : Math.round(head + 8)) + 'px';
    }

    /* Overlays go to <body>, wrapped in the same .v2 theme class so the tokens still apply */
    portal(el) {
      const wrap = document.createElement('div');
      wrap.className = this.root.className.replace('v2-pdp', 'v2-portal');
      wrap.removeAttribute('data-v2-product');
      wrap.appendChild(el);
      document.body.appendChild(wrap);
    }

    /* The variant for a set of options; if that exact one doesn't exist, the closest one that keeps the option just picked */
    find(options, keepIdx) {
      const exact = this.variants.find((v) => v.options.every((o, i) => o === options[i]));
      if (exact) return exact;
      const keep = this.variants.filter((v) => v.options[keepIdx] === options[keepIdx]);
      const score = (v) => v.options.reduce((n, o, i) => n + (o === options[i] ? 1 : 0), 0) + (v.available ? .5 : 0);
      return keep.sort((a, b) => score(b) - score(a))[0] || this.variants[0];
    }

    pick(idx, value) {
      const opts = this.options.slice();
      opts[idx] = value;
      const v = this.find(opts, idx);
      if (!v || v.id === this.current.id) return;
      this.current = v;
      this.options = v.options.slice();
      this.render(true);
    }

    render(changed) {
      const v = this.current;
      const root = this.root;
      if (this.input) {
        this.input.value = v.id;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (changed) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
        root.dispatchEvent(new CustomEvent('v2:variant-change', { bubbles: true, detail: { variant: v } }));
      }

      // Price
      const save = v.compare > v.price;
      const price = root.querySelector('[data-v2-price]');
      price.classList.toggle('is-save', save);
      root.querySelector('[data-v2-price-now]').textContent = v.priceF;
      const was = root.querySelector('[data-v2-price-was]');
      was.textContent = v.compareF; was.hidden = !save;
      const sv = root.querySelector('[data-v2-price-save]');
      sv.textContent = save ? 'Du sparer ' + v.saveF : ''; sv.hidden = !save;
      const note = root.querySelector('[data-v2-set-note]');
      if (note) note.hidden = !save;

      // Add to cart + stock
      const atc = root.querySelector('[data-v2-atc]');
      atc.disabled = !v.available;
      root.querySelector('[data-v2-atc-label]').textContent = v.available
        ? (this.config.isSet ? 'Læg sættet i kurv · ' : 'Læg i kurv · ') + v.priceF
        : 'Midlertidigt udsolgt';
      const stock = root.querySelector('[data-v2-stock]');
      stock.classList.toggle('is-out', !v.available);
      root.querySelector('[data-v2-stock-label]').textContent = v.available ? 'På lager · Levering på 1–3 hverdage' : 'Midlertidigt udsolgt';
      if (this.bar) {
        this.bar.querySelector('[data-v2-bar-price]').textContent = v.priceF;
        const bb = this.bar.querySelector('[data-v2-bar-btn]');
        bb.disabled = !v.available; bb.textContent = v.available ? 'Læg i kurv' : 'Udsolgt';
      }

      // Per-variant blocks
      root.querySelectorAll('[data-v2-for]').forEach((el) => { el.hidden = Number(el.dataset.v2For) !== v.id; });

      // Options: chosen state, label value, option badge, sold-out mark
      root.querySelectorAll('[data-v2-option]').forEach((box) => {
        const idx = Number(box.dataset.v2Option);
        // owner 9 Oct night: a variant badge only marks the option row where it makes a difference – if every value in
        // this row leads to the same badge (e.g. »Uden«/»Med« pumpe both at the bestselling size), the row shows none
        const rowKeys = [...box.querySelectorAll('.v2-seg__b, .v2-sw')].map((b) => {
          const o = this.options.slice(); o[idx] = b.dataset.value;
          const m = this.variants.find((x) => x.options.every((v2, i) => v2 === o[i])); return (m && m.badge) || '';
        });
        const rowSame = rowKeys.length > 1 && rowKeys.every((k) => k && k === rowKeys[0]);
        // … and never repeat a badge the top row already shows (e.g. »Bestseller« above the title and on »Ø26«)
        const topKeys = [...root.querySelectorAll('.v2-buy__top .v2-bdg')].map((s) => ((s.className.match(/v2-bdg--(\w+)/) || [])[1]) || '');
        box.querySelectorAll('.v2-seg__b, .v2-sw').forEach((b) => {
          const on = b.dataset.value === this.options[idx];
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-checked', String(on));
          const opts = this.options.slice(); opts[idx] = b.dataset.value;
          const match = this.variants.find((x) => x.options.every((o, i) => o === opts[i]));
          b.classList.toggle('is-na', !match || !match.available);
          const vlg = b.querySelector('[data-v2-vlg]');
          if (vlg) {
            const key = !rowSame && match && match.badge && !topKeys.includes(match.badge) ? match.badge : '';
            vlg.hidden = !key;
            if (key) { vlg.textContent = this.config.badgeLabels[key] || ''; vlg.className = 'v2-vlg v2-vlg--' + key; }
          }
          if (on) {
            const lbl = box.querySelector('[data-v2-opt-value]');
            if (lbl) lbl.textContent = b.classList.contains('v2-sw') ? b.getAttribute('aria-label') : b.textContent.replace(b.querySelector('[data-v2-vlg]') ? b.querySelector('[data-v2-vlg]').textContent : '', '').trim();
          }
        });
      });

      this.filterGallery(changed);
      this.filterFilms();
      this.renderDrawer();
      if (changed) this.fitSticky();
    }

    /* Films follow the variant the same way: a film tagged #Størrelse_20 cm shows only with 20 cm; untagged films always */
    matchTags(tagStr) {
      const tags = (tagStr || '').split('##').filter(Boolean);
      if (!tags.length || this.variants.length < 2) return true;
      const names = this.config.optionNames.map(lc);
      const sel = this.options.map(lc);
      const want = {};
      for (const tag of tags) {
        const cut = tag.indexOf('_');
        const idx = names.indexOf(lc(tag.slice(0, cut)));
        if (idx < 0) return false;
        let value = lc(tag.slice(cut + 1)).replace(/[,;]$/, '').trim();
        (want[idx] = want[idx] || []).push(value);
      }
      return Object.keys(want).every((i) => want[i].includes(sel[i]));
    }

    filterFilms() {
      const box = this.root.querySelector('[data-v2-films]');
      if (!box) return;
      const films = Array.from(box.querySelectorAll('.v2-film'));
      films.forEach((f) => { f.hidden = !this.matchTags(f.dataset.tags); });
      // owner 9 Oct night: fewer than 4 films in the chosen colour → other colours' recipe films fill up to 4 (no unboxing films)
      let shown = films.filter((f) => !f.hidden).length;
      for (const f of films) {
        if (shown >= 4) break;
        if (f.hidden && /(^|##)Farve_/.test(f.dataset.tags || '') && !/Udpakning/i.test(f.getAttribute('aria-label') || '')) { f.hidden = false; shown++; }
      }
      const n = films.filter((f) => !f.hidden).length;
      box.hidden = n === 0;
      const nEl = box.querySelector('[data-v2-films-n]');
      if (nEl) nEl.textContent = n;
      // owner 9 Oct: arrows when there are more films than fit (4 across); they page the row
      const row = box.querySelector('.v2-films__row');
      const nav = box.querySelector('[data-v2-films-nav]');
      const syncNav = () => {
        if (!row || !nav) return;
        const more = row.scrollWidth > row.clientWidth + 4;
        nav.hidden = !more;
        nav.querySelector('[data-v2-films-prev]').disabled = row.scrollLeft <= 2;
        nav.querySelector('[data-v2-films-next]').disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;
      };
      syncNav();
      if (!this.filmsBound) {
        this.filmsBound = true;
        if (row && nav) {
          nav.addEventListener('click', (e) => {
            const b = e.target.closest('button'); if (!b) return;
            row.scrollBy({ left: (b.hasAttribute('data-v2-films-next') ? 1 : -1) * row.clientWidth, behavior: 'smooth' });
          });
          row.addEventListener('scroll', () => { clearTimeout(this.filmNavT); this.filmNavT = setTimeout(syncNav, 60); }, { passive: true });
          window.addEventListener('resize', syncNav);
        }
        box.addEventListener('click', (e) => {
          const f = e.target.closest('.v2-film');
          if (!f) return;
          const list = films.filter((x) => !x.hidden);
          this.playFilm(list, list.indexOf(f));
        });
      }
    }

    playFilm(list, i) {
      this.filmList = list; this.filmIndex = i;
      if (!this.player) {
        const p = document.createElement('div');
        p.className = 'v2-player';
        p.setAttribute('role', 'dialog');
        p.setAttribute('aria-label', 'Film');
        p.innerHTML = '<video playsinline controls></video><button type="button" class="v2-player__x" aria-label="Luk film">×</button><button type="button" class="v2-player__nav v2-player__prev" aria-label="Forrige film">‹</button><button type="button" class="v2-player__nav v2-player__next" aria-label="Næste film">›</button>';
        p.querySelector('.v2-player__x').addEventListener('click', () => this.closeFilm());
        p.querySelector('.v2-player__prev').addEventListener('click', () => this.stepFilm(-1));
        p.querySelector('.v2-player__next').addEventListener('click', () => this.stepFilm(1));
        p.querySelector('video').addEventListener('ended', () => this.stepFilm(1));
        // desktop theatre (owner 9 Oct): a click on the dark backdrop or Esc closes
        p.addEventListener('click', (e) => { if (e.target === p) this.closeFilm(); });
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.closeFilm(); });
        this.player = p;
        this.portal(p);
      }
      const f = this.filmList[this.filmIndex];
      const video = this.player.querySelector('video');
      const hls = f.dataset.hls; const mp4 = f.dataset.src;
      video.src = (hls && video.canPlayType('application/vnd.apple.mpegurl')) ? hls : mp4;
      this.player.hidden = false;
      document.documentElement.classList.add('v2-theatre-on');
      const multi = this.filmList.length > 1;
      this.player.querySelectorAll('.v2-player__nav').forEach((b) => { b.hidden = !multi; });
      video.play().catch(() => {});
    }

    stepFilm(d) {
      if (!this.filmList || this.filmList.length < 2) return;
      this.filmIndex = (this.filmIndex + d + this.filmList.length) % this.filmList.length;
      this.playFilm(this.filmList, this.filmIndex);
    }

    closeFilm() {
      if (!this.player || this.player.hidden) return;
      const v = this.player.querySelector('video');
      v.pause(); v.removeAttribute('src'); v.load();
      this.player.hidden = true;
      document.documentElement.classList.remove('v2-theatre-on');
    }

    /* Gallery filter – an image with #Option_Value tags shows only when every option it names matches the variant;
       several tags for one option = any of them; a tag for an option the product doesn't have hides the image. */
    filterGallery(changed) {
      const names = this.config.optionNames.map(lc);
      const sel = this.options.map(lc);
      let firstShown = null;
      this.items.forEach((item) => {
        const tags = (item.dataset.tags || '').split('##').filter(Boolean);
        let show = true;
        if (tags.length && this.variants.length > 1 && Number(item.dataset.v2Media) !== this.current.media) {
          const want = {};
          for (const tag of tags) {
            const cut = tag.indexOf('_');
            const name = lc(tag.slice(0, cut));
            const value = lc(tag.slice(cut + 1));
            const idx = names.indexOf(name);
            if (idx < 0) { show = false; break; }
            (want[idx] = want[idx] || []).push(value);
          }
          if (show) show = Object.keys(want).every((i) => want[i].includes(sel[i]));
        }
        item.hidden = !show;
        item.style.order = '';
      });
      // The variant's own image leads
      const own = this.items.find((i) => Number(i.dataset.v2Media) === this.current.media);
      if (own && !own.hidden) { own.style.order = '-1'; firstShown = own; }
      this.items.forEach((i) => i.classList.remove('is-lead'));
      const lead = firstShown || this.items.find((i) => !i.hidden);
      if (lead) lead.classList.add('is-lead');
      const all = this.root.querySelector('[data-v2-count-all]');
      if (all) all.textContent = this.items.filter((i) => !i.hidden).length;
      if (changed && this.track && this.track.scrollWidth > this.track.clientWidth) this.track.scrollTo({ left: 0, behavior: 'smooth' });
      this.updateCount();
    }

    visibleItems() {
      return this.items.filter((i) => !i.hidden).sort((a, b) => (Number(a.style.order) || 0) - (Number(b.style.order) || 0));
    }

    updateCount() {
      const now = this.root.querySelector('[data-v2-count-now]');
      if (!now || !this.track) return;
      const w = this.track.clientWidth || 1;
      now.textContent = Math.min(this.visibleItems().length, Math.round(this.track.scrollLeft / w) + 1);
    }

    renderDrawer() {
      if (!this.drawer) return;
      const si = this.config.setIndex;
      const others = this.options.filter((o, i) => i !== si);
      const t = this.drawer.querySelector('[data-v2-drawer-title]');
      const rows = this.drawer.querySelectorAll('.v2-jrow');
      if (t) t.textContent = (rows.length === 2 ? 'Begge sæt' : 'Alle ' + rows.length + ' sæt') + (others.length ? ' – ' + others.map((o) => this.optionLabel(o)).join(' · ') : '');
      rows.forEach((row) => {
        const opts = this.options.slice(); opts[si] = row.dataset.value;
        const v = this.variants.find((x) => x.options.every((o, i) => o === opts[i]));
        const on = row.dataset.value === this.options[si];
        row.classList.toggle('is-on', on);
        row.setAttribute('aria-checked', String(on));
        if (!v) { row.hidden = true; return; }
        row.hidden = false;
        row.querySelector('[data-v2-jrow-now]').textContent = v.priceF;
        const save = v.compare > v.price;
        row.querySelector('[data-v2-jrow-was]').textContent = save ? v.compareF : '';
        const s = row.querySelector('[data-v2-jrow-save]');
        s.hidden = !save; s.textContent = save ? 'Du sparer ' + v.saveF : '';
        const b = row.querySelector('[data-v2-jrow-badge]');
        b.hidden = !v.badge;
        if (v.badge) { b.textContent = this.config.badgeLabels[v.badge] || ''; b.className = 'v2-bdg v2-bdg--' + v.badge; }
        const img = row.querySelector('[data-v2-jrow-img] img');
        if (img && v.img) { img.src = v.img; img.removeAttribute('srcset'); }
      });
    }

    optionLabel(value) {
      const map = { 'Uden': 'uden låg', 'Rustfrit stål': 'låg i stål', 'Glas': 'låg i glas' };
      return map[value] || lc(value);
    }

    openDrawer() {
      this.renderDrawer();
      this.drawer.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      const on = this.drawer.querySelector('.v2-jrow.is-on') || this.drawer.querySelector('.v2-jrow');
      if (on) on.focus({ preventScroll: true });
    }

    openUp() {
      const id = String(this.current.id);
      let group = null;
      this.updrw.querySelectorAll('[data-v2-upfor]').forEach((g) => { const on = g.dataset.v2Upfor === id; g.hidden = !on; if (on) group = g; });
      if (!group) return;
      if (!group.dataset.v2UpLid) this.upLid(group, group.dataset.v2UpDeflid || '');
      this.pickUp(group.querySelector('[data-v2-up-id].is-on:not([disabled]):not([hidden])') || group.querySelector('[data-v2-up-id]:not([disabled]):not([hidden])') || group.querySelector('[data-v2-up-id]:not([hidden])'));
      this.updrw.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      const on = group.querySelector('[data-v2-up-id].is-on');
      if (on) on.focus({ preventScroll: true });
    }

    // owner 9 Oct night: show the sets of one lid at a time (»Uden låg« / »Låg i stål« / »Låg i glas«)
    upLid(group, lid) {
      if (!group) return;
      const btns = [...group.querySelectorAll('[data-v2-up-lidbtn]')];
      if (btns.length && !btns.some((b) => b.dataset.v2UpLidbtn === lid)) lid = btns[0].dataset.v2UpLidbtn;
      group.dataset.v2UpLid = lid || '-';
      btns.forEach((b) => { const on = b.dataset.v2UpLidbtn === lid; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', String(on)); });
      let n = 0;
      group.querySelectorAll('[data-v2-up-id]').forEach((r) => { const show = !btns.length || !r.dataset.v2UpLid || r.dataset.v2UpLid === lid; r.hidden = !show; if (show) n++; });
      const c = group.querySelector('[data-v2-up-count]'); if (c) c.textContent = n;
      const cur = group.querySelector('[data-v2-up-id].is-on');
      if (!cur || cur.hidden) this.pickUp(group.querySelector('[data-v2-up-id]:not([disabled]):not([hidden])') || group.querySelector('[data-v2-up-id]:not([hidden])'));
    }

    closeUp() {
      if (!this.updrw || this.updrw.hidden) return;
      this.updrw.hidden = true;
      document.documentElement.style.overflow = '';
    }

    pickUp(row) {
      if (!row) return;
      row.parentElement.querySelectorAll('[data-v2-up-id]').forEach((r) => { const on = r === row; r.classList.toggle('is-on', on); r.setAttribute('aria-checked', String(on)); });
      this.updrw.querySelector('[data-v2-up-input]').value = row.dataset.v2UpId;
      const add = this.updrw.querySelector('[data-v2-up-add]');
      add.disabled = row.disabled;
      add.textContent = row.disabled ? 'Midlertidigt udsolgt' : 'Læg sættet i kurv · ' + row.dataset.v2UpPrice;
      this.updrw.querySelector('[data-v2-up-see]').href = row.dataset.v2UpUrl;
    }

    closeDrawer() {
      if (!this.drawer || this.drawer.hidden) return;
      this.drawer.hidden = true;
      document.documentElement.style.overflow = '';
    }

    openLightbox(item) {
      if (!this.lb) return;
      this.lbList = this.visibleItems();
      this.lbIndex = Math.max(0, this.lbList.indexOf(item));
      this.showLightbox();
      this.lb.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }

    showLightbox() {
      const item = this.lbList[this.lbIndex];
      const src = item && item.querySelector('img');
      const img = this.lb.querySelector('[data-v2-lb-img]');
      if (src) {
        const big = (src.currentSrc || src.src).replace(/width=\d+/, 'width=2000');
        img.src = big; img.alt = src.alt || '';
      }
    }

    stepLightbox(d) {
      if (!this.lbList || !this.lbList.length) return;
      this.lbIndex = (this.lbIndex + d + this.lbList.length) % this.lbList.length;
      this.showLightbox();
    }

    closeLightbox() {
      if (!this.lb || this.lb.hidden) return;
      this.lb.hidden = true;
      document.documentElement.style.overflow = '';
    }
  }

  // Category part (sections/v2-category.liquid): the cast-iron hero follows the chosen colour
  document.addEventListener('v2:variant-change', (e) => {
    const opts = (e.detail.variant.options || []).map(lc).join('|');
    const imgs = Array.from(document.querySelectorAll('[data-v2-color]'));
    const hit = imgs.find((i) => opts.includes(lc(i.dataset.v2Color)));
    if (!hit) return;
    imgs.forEach((i) => { i.hidden = i !== hit; });
    document.querySelectorAll('[data-v2-color-fallback]').forEach((i) => i.remove());
  });

  const init = () => document.querySelectorAll('[data-v2-product]').forEach((root) => {
    if (root.v2) return;
    try { root.v2 = new V2Product(root); } catch (e) { console.error('[v2-product]', e); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

// UX review 10 Oct: the GoWish app button has only an icon – give it a name for screen readers (the app renders it late)
(() => {
  const name = () => { const b = document.getElementById('gowishBlueButton'); if (b && !b.getAttribute('aria-label')) { b.setAttribute('aria-label', 'Sæt på ønskesedlen hos GoWish'); return true; } return false; };
  if (!name()) { let n = 0; const t = setInterval(() => { if (name() || ++n > 20) clearInterval(t); }, 500); }
})();
